module.exports = __webpack_public_path__ + "static/media/sf-trial-3.59d21b6a.mp3";